import { Spacing } from '@opallabs/gem'
import { useGemButtonState } from '@opallabs/gem-copilot/src/GemCopilotButton/useGemButtonState'

/**
 * How far a footer at the foot of the panel has to hold its content back from
 * its trailing edge, or undefined where it can use the inset it already has.
 *
 * The host draws the Gem button over the bottom trailing corner of the page,
 * on top of whatever the calendar puts there. A footer keeps this much of its
 * trailing edge empty so that what it holds — a summary, a way in — stays
 * readable and stays reachable. It is padding on the footer rather than a
 * narrower footer, so the line above it still runs the full width.
 */
export const useGemButtonClearance = (): number | undefined => {
  const { inlineInset, inlineSize, isVisible } = useGemButtonState()

  return isVisible ? inlineInset + inlineSize + Spacing.XS : undefined
}
